import React from "react";
import { RequestStatusCards } from "../RequestStatusCards";

// All / Pending / Approved / Rejected / Cancelled tallies. Clicking a tile
// filters the history table to that status (activeStatus); the "All" tile
// (empty filter value) shows the grand total and clears any active filter.
// Rendered through the shared RequestStatusCards so it matches Team
// Workspace > Approvals > Leave's status cards.
export const LeaveStatusCounts = ({ counts, activeStatus, onSelect }) => (
  <RequestStatusCards counts={counts} activeStatus={activeStatus} onSelect={onSelect} />
);
